import { render, staticRenderFns } from "./FormulateAgGrid.vue?vue&type=template&id=2326c9d5"
import script from "./FormulateAgGrid.vue?vue&type=script&lang=js"
export * from "./FormulateAgGrid.vue?vue&type=script&lang=js"
import style0 from "./FormulateAgGrid.vue?vue&type=style&index=0&id=2326c9d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports